module.exports = __webpack_public_path__ + "img/person-read.e1cae1e4.svg";